import type { PluginDefaultTranslationsObject, PluginLanguage } from '../types.js'

export const hrTranslations: PluginDefaultTranslationsObject = {
  $schema: './translation-schema.json',
  'plugin-form-builder': {
    name: 'Ime (mala slova, bez posebnih znakova)',
    add: 'Dodaj',
    allowedFileTypes: 'Dopuštene vrste datoteka',
    allowedFileTypesDescription:
      'Ograničite dopuštene vrste datoteka (npr. slika/*, aplikacija/pdf). Ostavite prazno da biste dopustili sve vrste.',
    allowMultipleFiles: 'Dopusti više datoteka',
    amountInCents: 'Iznos u centima',
    basePrice: 'Osnovna cijena',
    bcc: 'BCC',
    brand: 'Marka',
    cc: 'CC',
    checkboxPlural: 'Polja polja za potvrdu',
    checkboxSingular: 'Potvrdni okvir',
    checkedByDefault: 'Označeno prema zadanim postavkama',
    chooseConfirmationType:
      'Odaberite želite li prikazati poruku na stranici ili preusmjeriti na drugu stranicu nakon što pošalju obrazac.',
    condition: 'Stanje',
    confirmationMessage: 'Poruka potvrde',
    confirmationType: 'Vrsta potvrde',
    countryPlural: 'Country Fields',
    countrySingular: 'Država',
    creditCard: 'Kreditna kartica',
    customURL: 'Prilagođeni URL',
    datePlural: 'Datumska polja',
    dateSingular: 'Datum',
    defaultValue: 'Zadana vrijednost',
    divide: 'Podijeliti',
    documentToLinkTo: 'Dokument za povezivanje',
    doesNotEqual: 'Nije jednako',
    emailFrom: 'E-pošta od',
    emailPlural: 'Polja e-pošte',
    emailsDescription:
      'Pošalji prilagođenu e-poštu kada se obrazac pošalje. Koristite popise odvojene zarezima za slanje iste e-pošte većem broju primatelja. Za referencu na vrijednost iz ovog obrasca, stavite naziv tog polja u dvostruke vitičaste zagrade, tj. {{firstName}}. Možete koristiti zamjenski znak {{*}} za izlaz svih podataka i {{*:table}} za formatiranje kao HTML tablicu u e-poruci.',
    emailSingular: 'E-mail',
    emailTo: 'Pošalji e-poštom',
    equals: 'Jednako',
    field: 'Polje',
    fields: 'Polja',
    fieldWidth: 'Širina polja (postotak)',
    hasAnyValue: 'Ima bilo kakvu vrijednost',
    internalLink: 'Interna poveznica',
    label: 'Oznaka',
    maxFileSize: 'Maksimalna veličina datoteke (bajtovi)',
    maxFileSizeDescription:
      'Maksimalna veličina datoteke u bajtovima. Ostavite prazno ako nema ograničenja.',
    message: 'Poruka',
    messageDescription: 'Unesite poruku koja bi trebala biti poslana u ovoj e-pošti.',
    messagePlural: 'Blokovi poruka',
    messageSingular: 'Poruka',
    mimeType: 'Vrsta MIME',
    mimeTypePlural: 'MIME vrste',
    mimeTypeSingular: 'Vrsta MIME',
    multiply: 'Umnožiti',
    numberPlural: 'Polja brojeva',
    numberSingular: 'broj',
    optionPlural: 'Mogućnosti',
    optionSingular: 'Opcija',
    paymentFieldPlural: 'Polja plaćanja',
    paymentFieldSingular: 'Plaćanje',
    paymentProcessor: 'Procesor plaćanja',
    paymentStatus: 'Status',
    placeholder: 'Rezervirano mjesto',
    priceConditions: 'Uvjeti cijene',
    priceConditionsPlural: 'Uvjeti cijene',
    priceConditionsSingular: 'Cijena Stanje',
    radioOptions: 'Opcije atributa radija',
    radioPlural: 'Radio Fields',
    radioSingular: 'radio',
    redirect: 'Preusmjeri',
    replyTo: 'Odgovori na',
    required: 'Obavezno',
    selectOptions: 'Odaberite Opcije',
    selectPlural: 'Odaberite Polja',
    selectSingular: 'Odaberite',
    statePlural: 'Državna polja',
    stateSingular: 'Država',
    staticValue: 'Statička vrijednost',
    subject: 'Predmet',
    submitButton: 'Oznaka gumba Pošalji',
    subtract: 'Oduzmi',
    textareaPlural: 'Polja Textarea',
    textareaSingular: 'Textarea',
    textPlural: 'Tekstna polja',
    textSingular: 'Tekst',
    title: 'Naslov',
    token: 'token',
    uploadCollection: 'Prijenos zbirke',
    uploadCollectionDescription: 'Odaberite u koju zbirku za prijenos želite pohraniti datoteke',
    uploadFieldPlural: 'Polja za učitavanje',
    uploadFieldSingular: 'Upload',
    urlToRedirectTo: 'URL za preusmjeravanje',
    value: 'Vrijednost',
    valueOfField: 'Vrijednost polja',
    valueType: 'Vrsta vrijednosti',
  },
}

export const hr: PluginLanguage = {
  dateFNSKey: 'hr',
  translations: hrTranslations,
}
